export class Agency_BranchGroupsProperties {
  groupId: string = "";
  name: string = "";
  status: boolean = true;
  immediateParent: string = "";
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  selectedItems: string[] = [];
}

export class Agency_BranchGroupsDetailProperties {
  groupDetailId: number = 0;
  groupId: string = "";
  agency_branchId: string = "";
  status: boolean = true;

}
